"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AccountSettingsForm_1 = __importDefault(require("@/Components/AccountSettings/AccountSettingsForm"));
var react_i18next_1 = require("react-i18next");
var Tab_1 = __importDefault(require("@/Components/common/Tab"));
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var AdvancedSSO_1 = __importDefault(require("@/Components/AccountSettings/Sso/AdvancedSSO"));
var SimpleSSO_1 = __importDefault(require("@/Components/AccountSettings/Sso/SimpleSSO"));
var DesignPolicySettings_1 = __importDefault(require("./DesignPolicySettings"));
var AccountSettingsForm_module_css_1 = __importDefault(require("./AccountSettingsForm.module.css"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var AccountSettingsComponent = function () {
    var _a = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }), t = _a.t, i18n = _a.i18n;
    var _b = (0, react_1.useState)("organization"), active = _b[0], setActive = _b[1];
    var _c = (0, react_1.useState)(react_1.default.createElement(AccountSettingsForm_1.default, null)), RenderedTab = _c[0], setRenderedTab = _c[1];
    var termsUrl = i18n.language === "da" ? "https://nordicscreen.com/da/vilkar-betingelser" : "https://nordicscreen.com/terms";
    var page = (0, useTypedPage_1.default)();
    return (react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.contentContainer },
        react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.tabs },
            react_1.default.createElement(Tab_1.default, { onClick: function () { setActive("organization"); setRenderedTab(react_1.default.createElement(AccountSettingsForm_1.default, null)); }, text: t("Organization"), active: active === "organization", dataCy: "Organization" }),
            react_1.default.createElement(Tab_1.default, { onClick: function () { setActive("DesignPolicy"); setRenderedTab(react_1.default.createElement(DesignPolicySettings_1.default, null)); }, text: t("Design Policy"), active: active === "DesignPolicy", dataCy: "DesignPolicy" }),
            react_1.default.createElement(Tab_1.default, { text: t("Single Sign-On (SSO)"), onClick: function () {
                    setActive("sso");
                    if (page.props.advanced_sso_enabled) {
                        setRenderedTab(react_1.default.createElement(AdvancedSSO_1.default, null));
                    }
                    else {
                        setRenderedTab(react_1.default.createElement(SimpleSSO_1.default, null));
                    }
                }, active: active === "sso" }),
            react_1.default.createElement("a", { href: termsUrl, target: "_blank", rel: "noreferrer" },
                react_1.default.createElement(Tab_1.default, { text: t("Terms & Conditions") }))),
        RenderedTab));
};
exports.default = AccountSettingsComponent;
